import { AdvancedSearch } from '../search/advanced-search.model';
import { PlayErrorSearch } from '../search/play-error-search.model';
import {
    PlayDatabaseInteraction,
    PlayResultDetailsActionType,
    PlaySalesforceInteraction,
} from './reporting-data.model';

export class AppSpecificErrorCountSearch {
    executionId?: string;
    errorType?: string;
}

export interface ReportingSearch {
    fields?: ReportingSearchField[];
    groupByFields?: ReportingSearchField[];
}

export abstract class AbstractReportingSearch implements ReportingSearch {
    accountId?: string;
    fields: ReportingSearchField[] = [];
    groupByFields: ReportingSearchField[] = [];
    divisionId?: number;
    executionStartRangeBegin?: string;
    executionStartRangeEnd?: string;
    playId?: number;
}

export type PlayResultSearch = AbstractReportingSearch & {
    status?: string;
};

export type PlayResultDetailsCountsSearch = AbstractReportingSearch & {
    playResultId?: number;
    executionId?: string;
    actionType?: PlayResultDetailsActionType;
};

export type DatabaseInteractionSearch = AbstractReportingSearch & {
    playResultId?: number;
    executionId?: string;
    status?: string;
    databaseType?: string;
    databaseSystem?: string;
    advancedSearch?: AdvancedSearch<PlayDatabaseInteraction>[];
};

export type SalesforceInteractionSearch = AbstractReportingSearch & {
    playResultId?: number;
    executionId?: string;
    statusCode?: string;
    salesforceRecordId?: string;
    advancedSearch?: AdvancedSearch<PlaySalesforceInteraction>[];
};

export type PlayErrorReportingSearch = AbstractReportingSearch & PlayErrorSearch;

/**
 * @deprecated Use {@link TypedReportingSearchField} instead
 */
export class ReportingSearchField {
    tableName?: string;
    fieldName: string;
    aliasName?: string;
    functionType?: string;

    constructor(fieldName: string, tableName?: string, aliasName?: string, functionType?: string) {
        this.fieldName = fieldName;
        this.tableName = tableName;
        this.aliasName = aliasName;
        this.functionType = functionType;
    }
}

export class TypedReportingSearchField<T> {
    tableName?: ReportingTableName;
    fieldName: keyof T;
    aliasName?: string;
    functionType?: ReportingFunctionType;

    constructor(
        fieldName: keyof T,
        tableName?: ReportingTableName,
        aliasName?: string,
        functionType?: ReportingFunctionType
    ) {
        this.fieldName = fieldName;
        this.tableName = tableName;
        this.aliasName = aliasName;
        this.functionType = functionType;
    }
}

export type ReportingFunctionType = 'sum' | 'min' | 'max' | 'count' | 'constant';
export type ReportingTableName =
    | 'play_result'
    | 'play_result_detail'
    | 'play_salesforce_interaction'
    | 'play_database_interaction';
